<template>
  <v-container>
    <v-layout row wrap justify-space-between class="mt-2">
      <div class="headline">
        {{$t('dashboard.welcome')}}
        <span class="display-1">
          {{userName}}
        </span>
      </div>
      <div class="headline">
        {{$t('dashboard.total_students')}}
        <span class="display-1">
          {{totalStudents}}
        </span>
      </div>
    </v-layout>
    <custom-text msg="custom-text.dashboard" class="mt-3"></custom-text>
    <div v-for="(type, keyType) in filterTypes" v-if="!type.isNotTutor" class="pt-2">
      <filter-button v-for="(button, keyName) in type.values" :key="keyName" :text="button.text"
                   :filter-type="keyType" :filter-name="keyName"
                   :enabled="button.value"
                   @filter:click="filterChangeInner"
                   :icon="button.icon"
                   :disabled="disabled"/>
    </div>
    <v-layout row wrap justify-start class="mt-3">
      <v-flex xs12 sm4 md4 lg3 xl2 class="mb-3">
        <dashboard-engagement></dashboard-engagement>
      </v-flex>
      <v-flex xs12 sm4 md4 lg3 xl2 class="mb-3">
        <dashboard-engagement-table></dashboard-engagement-table>
      </v-flex>
      <v-flex v-if="flagEnableInteractionsCard" xs12 sm4 md4 lg3 xl2 class="mb-3">
        <dashboard-interactions></dashboard-interactions>
      </v-flex>
      <v-flex v-if="flagEnableAlertsCard" xs12 sm4 md4 lg3 xl2 class="mb-3">
        <dashboard-alerts/>
      </v-flex>
    </v-layout>
    <div v-if="flagDisplayCreateChart">
        <v-divider class="my-2"></v-divider>
        <v-layout row wrap justify-space-between class="mt-2">
          <v-btn id="create-chart-btn" color="primary" class="primary-text" @click="showCreateChartDialog" :outline="chartLimitReached" :disabled="chartLimitReached">
            <v-dialog v-model="createChartDialog" max-width="350">
              <create-chart-modal/>
            </v-dialog>
            <v-icon left>add</v-icon>
            <span>{{$t('dashboard.create')}}</span>
          </v-btn>
        </v-layout>
        <custom-text msg="custom-text.dashboard_charts" class="mt-2 mb-1"></custom-text>
        <v-container fluid grid-list-lg>
          <transition-group name="fade" tag="div" class="layout row wrap">
            <dashboard-graph-card
              v-for="(graph, key) in dashboardGraphs"
              v-if="!graph.isHidden"
              :key="graph.id"
              :graph="graph"
              :graph-key="key">
            </dashboard-graph-card>
          </transition-group>
        </v-container>
    </div>
  </v-container>
</template>

<script>
  import DashboardEngagement from './DashboardEngagement'
  import DashboardEngagementTable from './DashboardEngagementTable'
  import DashboardInteractions from './DashboardInteractions'
  import CreateChartModal from './CreateChartModal'
  import DashboardGraphCard from './DashboardGraphCard'
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { USER_NAME, HAS_FEATURE_FLAG } from '../../store/getter-types'
  import {
    GET_STUDENTS_COUNT,
    GET_ENGAGEMENT_LAST_SUCCESSFUL,
    DASHBOARD_CHANGE_FILTER,
    GET_DASHBOARD_GRAPHS, GET_COURSES_FOR_CHARTS
  } from '../../store/action-types'
  import DashboardAlerts from './DashboardAlerts'
  import CustomText from '../help/CustomText'
  import DateFormat from '../../mixins/DateFormat'
  import FilterButton from '../filter/FilterButton'
  import { SET_CREATE_CHART_DIALOG_VISIBILITY } from '../../store/mutation-types'

  export default {
    name: 'DashboardPage',
    data () {
      return {
        dialog: false
      }
    },
    mixins: [DateFormat],
    computed: {
      ...mapState({
        totalStudents: state => state.dashboard.studentsCount,
        filterTypes: state => state.dashboard.filterFields,
        disabled: state => state.dashboard.loading,
        dashboardGraphs: state => state.dashboard.dashboardGraphs,
        chartsCached: state => state.dashboard.chartsCached,
        chartLimitReached: state => state.profile.chartLimitReached,
        moduleAlert: state => state.profile.module.alert,
        moduleInsights: state => state.profile.module.insights,
        moduleInterExem: state => state.profile.module.interexem,
        functionDashboard: state => state.dashboard.functions.dashboard,
        functionChart: state => state.dashboard.functions.chart,
        optionEnableAlertsCard: state => state.dashboard.options.enable.alertsCard,
        optionEnableCreateChart: state => state.dashboard.options.enable.createChart,
        optionEnableInteractionsCard: state => state.dashboard.options.enable.interactionsCard
      }),
      ...mapGetters({
        userName: USER_NAME,
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      createChartDialog: {
        get () {
          return this.$store.state.dashboard.createChartDialogVisible
        },
        set (value) {
          this.$store.commit(SET_CREATE_CHART_DIALOG_VISIBILITY, value)
        }
      },
      flagEnableAlertsCard () {
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionDashboard + '.' + this.optionEnableAlertsCard)
      },
      flagDisplayCreateChart () {
        return this.hasFeatureFlag(this.moduleInsights + '.' + this.functionChart + '.' + this.optionEnableCreateChart)
      },
      flagEnableInteractionsCard () {
        return this.hasFeatureFlag(this.moduleInterExem + '.' + this.functionDashboard + '.' + this.optionEnableInteractionsCard)
      }
    },
    methods: {
      ...mapActions({
        getStudentsCount: GET_STUDENTS_COUNT,
        getEngagementLastSuccessful: GET_ENGAGEMENT_LAST_SUCCESSFUL,
        filterChange: DASHBOARD_CHANGE_FILTER,
        getDashboardGraphs: GET_DASHBOARD_GRAPHS,
        getChartFilters: GET_COURSES_FOR_CHARTS
      }),
      filterChangeInner (filterObject) {
        if (!this.disabled) {
          this.filterChange(filterObject)
        }
      },
      showCreateChartDialog () {
        this.createChartDialog = true
      }
    },
    components: {
      DashboardAlerts,
      DashboardEngagement,
      DashboardEngagementTable,
      DashboardInteractions,
      CustomText,
      CreateChartModal,
      FilterButton,
      DashboardGraphCard
    },
    mounted () {
      if (!this.chartsCached) {
        this.getStudentsCount()
        this.getEngagementLastSuccessful()
        this.getDashboardGraphs({chartId: null, append: false, update: false})
        this.getChartFilters()
      }
    }
  }
</script>

<style scoped>
  .display-1 {
    font-size: 24px;
    font-weight: bold;
  }

  .headline {
    font-size: 22px;
  }
  .headline-2 {
    font-size: 16px;
  }

  .text-bold {
    font-weight: bolder;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .fade-enter-to, .fade-leave {
    transition: opacity .5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardPage.vue